import React, { useEffect } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; // Add useDispatch
import {
  setSegments,
  clearSegments,
} from "../../../../store/redux_auth/authSlice"; // Import actions
import SegmentMenu from "../../../../components/navegation/SegmentMenu";
import EmptyState from "../../../../components/ui/pages/EmptyState";
import ExpertiseContent from "../../../../components/ui/account/ExpertiseContent";
import AvailabilityContent from "../../../../components/ui/account/AvailabilityContent";
import { useGetAccountQuery } from "../../../../api/account";

const AccountPreferences = () => {
  const dispatch = useDispatch(); // Initialize dispatch
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { data: accountInfo, isLoading } = useGetAccountQuery();
  const currentSection = searchParams.get("section") || "skills-expertise";

  const preferences = user?.preferences || accountInfo?.preferences;

  // Redirect to default section
  useEffect(() => {
    if (!searchParams.get("section")) {
      navigate("/account/preferences?section=skills-expertise", {
        replace: true,
      });
    }
  }, [searchParams, navigate]);

  // Generate segments (Keep this logic as is)
  const preferenceSegments = React.useMemo(() => {
    const segments = [];
    if (preferences?.skills_expertise) {
      segments.push({
        path: "/account/preferences?section=skills-expertise",
        text: "Skills & Expertise",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/expertise_black.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/expertise_blue.svg`,
      });
    }
    if (preferences?.availability) {
      segments.push({
        path: "/account/preferences?section=availability",
        text: "Availability",
        normalIcon: `${process.env.PUBLIC_URL}/images/icons/availability_black.svg`,
        activeIcon: `${process.env.PUBLIC_URL}/images/icons/availability_blue.svg`,
      });
    }
    return segments;
  }, [preferences]);

  // TELEPORTATION EFFECT
  useEffect(() => {
    if (preferenceSegments.length > 0) {
      dispatch(setSegments(preferenceSegments));
    }

    return () => dispatch(clearSegments());
  }, [dispatch, preferenceSegments]);

  if (!preferences && !isLoading) {
    return (
      <div className="main-content-area">
        <div className="content">
          <EmptyState
            title="You're all caught up!"
            text="No preferences are available for your account at this time."
          />
        </div>
      </div>
    );
  }

  return (
    <div className="main-content-area">
      <div className="content">
        <div className="ich-wrapper">
          <div className="internal-content-header">
            {/* Desktop Menu remains here */}
            <SegmentMenu
              segments={preferenceSegments}
              currentPath={location.pathname + location.search}
            />
          </div>
        </div>
        <div className="internal-content-body">
          {currentSection === "skills-expertise" && <ExpertiseContent />}
          {currentSection === "availability" && <AvailabilityContent />}
        </div>
      </div>
    </div>
  );
};

export default AccountPreferences;
